import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-flat-operations',
    templateUrl: './flat-operations.component.html',
    styleUrls: ['./flat-operations.component.scss'],
    standalone: false
})
export class FlatOperationsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
